"use client"

import {
  StatusBadge as StatusBadgePrimitive,
  type StatusBadgeProps,
} from "@exxatdesignux/ui/components/status-badge"
import { cn } from "@/lib/utils"

export {
  STATUS_BADGE_BOARD_SHELL,
  STATUS_BADGE_INSPECTOR_SHELL,
  STATUS_BADGE_SEMANTIC_MD_SHELL,
  STATUS_BADGE_SEMANTIC_SM_SHELL,
  STATUS_BADGE_TABLE_SHELL,
  STATUS_BADGE_TONE_CLASS,
  statusBadgeVariants,
  type StatusBadgeProductProps,
  type StatusBadgeProductStatus,
  type StatusBadgeProps,
  type StatusBadgeSemanticProps,
  type StatusBadgeSemanticSize,
  type StatusBadgeSurface,
  type StatusBadgeTone,
} from "@exxatdesignux/ui/components/status-badge"

/** Match Badge `has-data-[icon=inline-start]` padding for visual balance. */
const STATUS_BADGE_ICON_LEADING_SHELL = "gap-1 ps-1.5 pe-2"

export function StatusBadge(props: StatusBadgeProps) {
  if (props.status !== undefined) {
    return <StatusBadgePrimitive {...props} />
  }

  const { icon, className, ...rest } = props
  return (
    <StatusBadgePrimitive
      {...rest}
      icon={icon}
      className={cn(icon ? STATUS_BADGE_ICON_LEADING_SHELL : undefined, className)}
    />
  )
}
